import React, { Component } from 'react';

class WallNavLetterTile extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      visible: false,
    }
  }

  componentDidMount() {
    if (
      parseInt(this.props.location.nid) === 4441 ||
      (this.props.prevLocation && this.props.prevLocation.node.title.charAt( 0 ) !== this.props.location.title.charAt( 0 ))
    ) {
      this.setState( {
        visible: true
      } )
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (
        parseInt(this.props.location.nid)  === 4441 ||
        (this.props.prevLocation && this.props.prevLocation.node.title.charAt( 0 ) !== this.props.location.title.charAt( 0 ))
      ) {
        this.setState( {
          visible: true
        } )
      } else {
        this.setState( {
          visible: false
        } )
      }
    }
  }

  render() {
    if ( this.state.visible && parseInt(this.props.wall) !== 9 ) {
      return (
        <li className="WallNavLetterTile">
        </li>
      )
    } else {
      return false;
    }

  }
}

export default WallNavLetterTile;